/**
 * IntegrationRepository
 *
 * Define os templates de contexto para eventos do domínio de integrações externas
 * (Bitrix, Active Campaign, Circle, Memberkit, VoompPlay, etc.).
 * Regra: NUNCA incluir tokens, URLs com credenciais ou API keys.
 */

const IntegrationRepository = {
  /**
   * Template para falha em fetch de recurso de integração.
   * @param {{ provider?: string, resource?: string }} ctx
   * @returns {{ tags: object, extra: object }}
   */
  buildFetchContext(ctx = {}) {
    return {
      tags: {
        flow: 'integration_fetch',
        domain: 'integration',
        provider: ctx.provider ?? 'unknown',
      },
      extra: {
        resource: ctx.resource,
      },
    };
  },
};

export default IntegrationRepository;
